
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FormSection from './components/FormSection';

const FormulairePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <FormSection />
      </main>
      <Footer />
    </div>
  );
};

export default FormulairePage;
